import { ControllerContract } from '../architecture/ControllerContract';

import { getChatById } from '../models/chat/GetChatById';
import { createChat } from '../models/chat/CreateChat';
import { sendMessage } from '../models/chat/SendMessage';
import { updateChatContext } from '../models/chat/UpdateChatContext';

export const chatRoutes = {
    controllerPath: 'chat',
    endpoints: {
        getChatById,
        createChat,
        updateChatContext,
        sendMessage
    }
} as const satisfies ControllerContract;

export type ChatRoutes = typeof chatRoutes;
